import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import Helpers from "../Helper/Helpers";
import Swal from "sweetalert2";
const AvailableOn = () => {
  const [users, setUsers] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [status, setStatus] = useState(true);
  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [image, setImage] = useState("");
  const [id, setId] = useState("");
  const fileInputRef = useRef(null);

  console.log("userssf", users);

  useEffect(() => {
    FetchAllSubCategory();
  }, []);

  const handleClearImage = () => {
    setImage(""); // Clear the image state

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input field
    }
  };

  const FetchAllSubCategory = async () => {
    try {
      const res = await Helpers("/admin/banner/get", "GET");
      if (res && res?.status) {
        setUsers(res?.data?.reverse());
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchAllCategory = async () => {
    try {
      const res = await Helpers("/admin/banner/get", "GET");
      if (res && res?.status) {
        setAllCategory(res?.data?.reverse());
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpdate = (user) => {
    setStatus(false);

    setImage(user?.image);

    setId(user?._id);
  };

  const handleUpdateBanner = async (e) => {
    e.preventDefault();
    let data = {
      image: image,
    };

    if (image) {
      try {
        const res = await Helpers(`/admin/banner/update/${id}`, "PUT", data);
        if (res && res?.status) {
          toast.success("Banner Updated Successfully.");

          setImage("");

          FetchAllSubCategory();
        } else {
          toast.error("Failed to update banner.");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error("All fields are required.");
    }
  };

  const handleDeleteUser = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      const res = await Helpers(`/admin/banner/delete/${id}`, "DELETE", {});
      if (res && res?.status) {
        toast.success("Deleted Successfully");
        FetchAllSubCategory();
      } else {
        toast?.error("Deletion failed");
      }
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;

  // Calculate the indexes for slicing the users array
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  // Pagination control functions
  const handleNextPage = () => {
    if (currentPage < Math.ceil(users.length / usersPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const HandleImage = async (e) => {
    let file = e.target.files[0];
    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const data = new FormData();
    data.append("image", file);

    try {
      const response = await fetch(
        "http://3.111.171.1:8001/api/v1/upload-image",
        {
          method: "POST",
          body: data, // `FormData` is directly used as the request body
        }
      );

      if (!response.ok) {
        toast.error("Only images (jpeg, jpg, png, gif) are allowed");
      }

      const res = await response.json();

      if (res?.url) {
        setImage(res.url);
      } else {
        // toast.error("Failed to upload profile image");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      toast.error(error.message || "An error occurred while uploading.");
    }
  };

  const HandleAddBanner = async (e) => {
    e.preventDefault();
    let data = {
      image: image,
    };

    if (image) {
      try {
        const res = await Helpers("/admin/banner/add", "POST", data);
        if (res && res?.status) {
          toast.success("Banner Added Successfully.");

          setImage("");

          FetchAllSubCategory();
        } else {
          toast.error("Failed to add banner.");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error(" Field is required.");
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-8">{status ? "Add" : "Update"}</h1>
      <div className="mb-8 flex flex-col items-center">
        {" "}
        {/* Centering content horizontally */}
        <h2 className="text-xl font-semibold mb-9">
          {" "}
          {status ? "Add" : "Update"} Banner
        </h2>{" "}
        {/* Added margin for spacing */}
      </div>
      <div className="flex flex-wrap justify-between items-start gap-4 mb-6">
        {/* Upload Image */}
        <div className="w-full md:w-[32%]">
          <label
            htmlFor="imageUpload"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Upload Image:
          </label>
          <div className="relative w-full">
            <input
              type="file"
              accept="image/*"
              id="imageUpload"
              onChange={HandleImage}
              className="hidden"
            />
            <label
              htmlFor="imageUpload"
              className="block border p-2 rounded text-center cursor-pointer"
              style={{ border: "1px solid gray" }}
            >
              Upload Image
            </label>
          </div>

          {image && (
            <div className="flex items-center mt-2">
              <img
                style={{ height: "5rem", width: "10rem" }}
                alt=""
                src={image}
                ref={fileInputRef}
                id="profileimage"
              />
              <span
                style={{
                  cursor: "pointer",
                  color: "red",
                  marginLeft: "9px",
                  fontWeight: 600,
                }}
                onClick={() => {
                  setImage("");
                  handleClearImage();
                }}
              >
                X
              </span>
            </div>
          )}
        </div>
      </div>
      {/* Submit Button on next row, right aligned */}
      <div className="flex justify-end">
        <button
          className="bg-blue-500 text-white px-6 py-2 rounded"
          onClick={status ? HandleAddBanner : handleUpdateBanner}
        >
          {status ? "Submit" : "Update"}
        </button>
      </div>
      {/* Users Table */}
      <h2 className="text-xl font-semibold mb-9 flex">Manage Banners</h2>{" "}
      <div className="bg-white shadow-md rounded-lg p-6">
        <div className="overflow-x-auto">
          <table className="w-full table-fixed min-w-[600px]">
            <thead>
              <tr className="bg-gray-200 text-left">
                <th className="p-4 w-1/12">ID</th>
                <th className="p-4 w-3/12">Banner Image</th>
                <th className="p-4 w-2/12">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user, index) => (
                <tr key={user.id} className="border-t">
                  <td className="p-4 truncate">
                    {indexOfFirstUser + index + 1}
                  </td>
                  <td className="p-4">
                    <img
                      className="h-12 w-24 object-cover rounded"
                      src={user?.image}
                      alt="SubCategory"
                    />
                  </td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleUpdate(user)}
                        className="bg-blue-500 text-white p-2 rounded"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteUser(user._id)}
                        className="bg-red-500 text-white p-2 rounded"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination controls */}
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="bg-blue-500 text-white p-2 rounded disabled:bg-gray-300"
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {Math.ceil(users.length / usersPerPage)}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage >= Math.ceil(users.length / usersPerPage)}
            className="bg-blue-500 text-white p-2 rounded disabled:bg-gray-300"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvailableOn;
